import { PLANT_TYPE } from '../data/plants.js';

export function uniqueVariableTypes(portfolio, plantsById) {
  const seen = new Set();
  for (const id of portfolio) {
    if (plantsById[id].type === PLANT_TYPE.VARIABLE) seen.add(id);
  }
  return [...seen];
}

export function rollVariableOutputs(portfolio, plantsById, rng) {
  const out = {};
  for (const id of uniqueVariableTypes(portfolio, plantsById)) {
    const { min, max } = plantsById[id].output;
    out[id] = rng.uniform(min, max);
  }
  return out;
}
